import { Controller } from "@hotwired/stimulus"

// Drives the customer document-request page: picking a document type, adding
// it to the selected list, choosing recipients, and gating the Send button
// (plus keeping the send confirmation's body in sync with the selections).
export default class extends Controller {
  static targets = [
    "addButton",
    "card",
    "cardTemplate",
    "emptyState",
    "form",
    "otherTitleInput",
    "otherTitleWrapper",
    "previewButton",
    "recipientCheckbox",
    "selectedList",
    "sendButton",
    "typeRadio",
  ]

  connect() {
    this.refresh()
  }

  add = () => {
    const radio = this.checkedRadio()
    if (!radio) return

    const name = radio.value === "Other" ? this.otherTitleInputTarget.value.trim() : radio.value
    if (name === "" || this.selectedNames().includes(name)) return

    const template = this.cardTemplateTargets.find(
      (candidate) => candidate.dataset.documentType === radio.value
    )
    const card = template.content.firstElementChild.cloneNode(true)
    card.querySelector("[data-document-request-label]").textContent = name
    card.querySelector("input[type=hidden]").value = name
    this.selectedListTarget.appendChild(card)

    radio.checked = false
    this.otherTitleInputTarget.value = ""
    this.refresh()
  }

  refresh = () => {
    const radio = this.checkedRadio()
    const otherChecked = radio?.value === "Other"

    this.otherTitleWrapperTarget.hidden = !otherChecked
    this.addButtonTarget.disabled =
      !radio || (otherChecked && this.otherTitleInputTarget.value.trim() === "")

    const documentCount = this.selectedNames().length
    this.emptyStateTarget.hidden = documentCount > 0

    const recipients = this.checkedRecipients()
    this.previewButtonTarget.disabled = documentCount === 0
    this.sendButtonTarget.disabled = documentCount === 0 || recipients.length === 0

    this.formTarget.dataset.body = this.confirmationBody(documentCount, recipients)
  }

  remove = (event) => {
    event.currentTarget.closest("[data-document-request-target='card']").remove()
    this.refresh()
  }

  checkedRadio() {
    return this.typeRadioTargets.find((radio) => radio.checked)
  }

  checkedRecipients() {
    return this.recipientCheckboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)
  }

  confirmationBody(documentCount, recipients) {
    const documents = `${documentCount} document${documentCount === 1 ? "" : "s"}`
    return [
      `This will email a request for ${documents} to:`,
      recipients.join("\n"),
      "Emails cannot be unsent — please make sure the requested documents and recipients are correct before sending.",
    ].join("\n\n")
  }

  selectedNames() {
    return this.cardTargets.map((card) => card.querySelector("input[type=hidden]").value)
  }
}
